document.querySelectorAll('.form-input-range input[type="range"]').forEach((range) => {
  updateFill(range)
  range.addEventListener('input', () => updateFill(range))
})

function updateFill(input) {
  const min = input.min || 0
  const max = input.max || 100
  const percent = ((input.value - min) / (max - min)) * 100
  input.style.setProperty('--fill', `${percent}%`)

  const container = input.closest('.form-input-range')
  if (container) {
    const output = container.querySelector('.base-value input[type="text"]')
    if (output) {
      output.value = `\u20AC${Number(input.value).toLocaleString('en-IE')}`
    }
  }
}
